var map = {
	"./address_image.svg": 129,
	"./animated_ashutosh.png": 130,
	"./animated_logo.svg": 131,
	"./blogs_image.svg": 132,
	"./cloud_infrastructure.svg": 133,
	"./codeInLogo.png": 134,
	"./contactMail.png": 135,
	"./coursera_logo.png": 136,
	"./data_science.svg": 137,
	"./datacamp.png": 138,
	"./datacamp.webp": 139,
	"./deeplearning_ai_logo.png": 140,
	"./delhivery_logo.png": 141,
	"./developerActivity.svg": 142,
	"./dsc_logo.png": 143,
	"./education.svg": 144,
	"./experience.svg": 145,
	"./feelingProud.svg": 146,
	"./freecopy_logo.png": 147,
	"./fullstack.svg": 148,
	"./gcp_logo.png": 149,
	"./github_logo.png": 150,
	"./googleAssistant.jpg": 151,
	"./googleAssistant.svg": 152,
	"./google_logo.png": 153,
	"./hec.png": 154,
	"./ibm_logo.png": 155,
	"./iiitk_logo.png": 156,
	"./intel_logo.jpg": 157,
	"./iu_logo.png": 158,
	"./jsFramework.svg": 159,
	"./legato_logo.png": 160,
	"./linkedin.png": 161,
	"./manOnTable.svg": 162,
	"./microsoft_logo.png": 163,
	"./motive.png": 164,
	"./motive.webp": 165,
	"./mozilla_logo.png": 166,
	"./muffito_logo.png": 167,
	"./nextuLogo.jpg": 168,
	"./nptel_logo.png": 169,
	"./nrpu.png": 170,
	"./nuces-logo.png": 171,
	"./portfolio.gif": 172,
	"./profile.jpeg": 173,
	"./programmer.svg": 174,
	"./projects_image.svg": 175,
	"./pwa.png": 176,
	"./saayaHealthLogo.png": 177,
	"./stanford_logo.png": 178,
	"./talksCardBack.svg": 179,
	"./talksCardBackAlt.svg": 180,
	"./tiktok_logo.png": 181,
	"./udemy.png": 182,
	"./ui_ux_design.svg": 183,
	"./venture-dive.png": 184
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 33;